import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import {
  DashboardEnrollmentPresenter,
  EnrollmentPeriod,
  EnrollmentStage,
  EnrollmentType,
  ProductType,
  Proposal,
} from 'types/enrollmentService';

export function renewalProductLineName(sponsorId: string, productLineId: ProductLineId): string {
  return `${sponsorId}_RENEWAL_${productLineId}`;
}

/**
 * Creates list of lines that "Active" for the Group.
 * Later we will use it not to give ability for the user to change plan for sponsors that do not allow it
 */
export function getCoveredProductLines(periods: EnrollmentPeriod[]): ProductLineId[] {
  // Save product lines that already covered, so for the Renewals for some carriers they won't be able to browse them
  const installedProductLineIds = periods
    .filter((period) => !!period.installedProposal)
    .map((period) => period.installedProposal?.productLines.map((line) => line.id) || [])
    .flat();
  const soldProductLineIds = periods
    .filter((period) => period.stage === EnrollmentStage.SOLD)
    .map((period) => period.productLineIds)
    .flat();

  return [...installedProductLineIds, ...soldProductLineIds];
}

/**
 * Returns enrollment periods that have the 'hasConfirmedProposal' property set to true.
 */
export function getActiveEPeriods(enrollmentPeriods: EnrollmentPeriod[]): EnrollmentPeriod[] {
  return enrollmentPeriods.filter((enrollmentPeriod) => enrollmentPeriod.hasConfirmedProposal);
}

/**
 * Returns enrollment periods with the types 'NEW_SALE' or 'RESUBMIT_NEW_SALE'.
 */
export function getNewSaleEPeriods(enrollmentPeriods: EnrollmentPeriod[]): EnrollmentPeriod[] {
  return enrollmentPeriods.filter(
    (enrollmentPeriod) =>
      enrollmentPeriod.type === EnrollmentType.NEW_SALE || enrollmentPeriod.type === EnrollmentType.RESUBMIT_NEW_SALE,
  );
}

/**
 * Returns enrollment periods that have the 'stage' property set to 'QUOTING'.
 */
export function getQuotingPeriods(enrollmentPeriods: EnrollmentPeriod[]): EnrollmentPeriod[] {
  return enrollmentPeriods.filter((enrollmentPeriod) => enrollmentPeriod.stage === EnrollmentStage.QUOTING);
}

export function mapEnrollmentsToGroups(
  enrollments: DashboardEnrollmentPresenter[],
): Record<string, DashboardEnrollmentPresenter[]> {
  return (
    enrollments.reduce((acc, current) => {
      const groupId = current.groupId;
      if (!acc[groupId]) {
        acc[groupId] = [];
      }
      acc[groupId].push(current);
      return acc;
    }, {} as Record<string, DashboardEnrollmentPresenter[]>) || {}
  );
}

export function isRenewOrCancelProductLine(productLineId: ProductLineId, confirmedProposal?: Proposal | null): boolean {
  if (confirmedProposal) {
    const productLine = confirmedProposal.productLines.find((line) => line.id === productLineId);
    return (
      !!productLine && (productLine.productType === ProductType.RENEW || productLine.productType === ProductType.CANCEL)
    );
  }
  return false;
}
